import { round } from 'lodash'
import { Vue, Component, Prop, Inject } from 'vue-property-decorator'
import RecommendPrice from '../recommend_price.vue'
import './RecommendItem.scss'

@Component({
  components: {
    RecommendPrice,
  },
  filters: {
    distanceKm(m: number) {
      if (m <= 100) {
        return '0.1'
      } else {
        const km = round(m / 1000, 1).toString()
        if (km.split('.').length == 1) {
          return `${km}.0`
        } else {
          return `${km}`
        }
      }
    },
    filterUnicode(content: string) {
      if (content) {
        try {
          // 接口返回内容可能包含unicode编码，转中文
          return unescape(content.replace(/\\u([0-9a-f]{4})/g, '%u$1'))
        } catch (e) {
          return content
        }
      }
      return ''
    },
  },
})
export default class RecommendItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any
  @Prop() readonly showItem!: boolean
  @Prop() readonly moduleId!: string
  @Prop({ default: () => ({}) }) readonly tab!: any

  @Inject('pageTrackParams')
  pageTrackParams!: any

  /* 商品是否需要隐藏"商家名称"和"距离" */
  get hideCmmdtyAddress() {
    if (this.moduleId != '1001') {
      return false
    }
    const level4CategoryId = Number(this.value.level4CategoryId)
    /* 针对以下四级品类的商品，直接隐藏"商家名称"和"距离" */
    const flag1 = [
      10101010,
      10101011,
      10101012,
      10101013,
      10101014,
      10101015,
      10101016,
      10101110,
      10101111,
      10101112,
      10101113,
      10101210,
      10101211,
      10101212,
      10101310,
      10101311,
      10101312,
      10101410,
      10101411,
      10101412,
      10101413,
      10101414,
      10101415,
      10101610,
      10101710
    ].indexOf(level4CategoryId) > -1
    if (flag1) {
      return true
    }
    /* 针对以下四级品类的商品，当商品模板不是门票时，隐藏"商家名称"和"距离" */
    const flag2 = [
      10121010,
      10121011,
      10121012,
      10121013,
      10121014,
      10121015,
      10121016,
      10121017,
      10121018,
      10121020].indexOf(level4CategoryId) > -1
    if (flag2 && this.value.templateType2Id != 601) {
      return true
    }
    return false
  }

  /* 商品是否需要隐藏适用年龄段标签 */
  get hideApplicableAge() {
    if (this.moduleId != '1001') {
      return false
    }
    const level4CategoryId = Number(this.value.level4CategoryId)
    /* 针对以下四级品类的商品，隐藏适用年龄段标签 */
    const flag1 = [
      10111112, // 抚触
      10111113, // 理发
      10111114, // 推拿
      10111017, // 营养餐[育儿服务]
      10111018, // 月子中心[育儿服务]
      10111020, // 育儿嫂[育儿服务]
      10111021, // 孕产陪护
      10111025, // 乳房护理
      10112110, // 产康
      10112111, // 产康
      10112112, // 产康
      10112113, // 产康
      10112114, // 产康
      10112115, // 产康
      10112116, // 产康
    ].indexOf(level4CategoryId) > -1
    if (flag1) {
      return true
    }
    return false
  }

  /* 返回带kwtarget=blank的url */
  kwtarget(url: string | undefined) {
    if (url) {
      url = String(url)
      const idx = url.indexOf('?')
      if (idx < 0) {
        url += '?'
      } else if (idx >= 0 && idx != url.length - 1) {
        url += '&'
      }
      url += 'kwtarget=blank'
      return url
    }
    return ''
  }

  mounted() {
    setTimeout(() => {
      /* 解决门店名称溢出时的省略号右边间隙过大问题 */
      /* 判断一下门店名称是否溢出，溢出则将分割线的左间距小一点点 */
      const addressName = this.$el.querySelector('.address-name') as HTMLElement
      const scrollWidth = addressName && addressName.scrollWidth  // 实际宽度，包含超出部分
      const clientWidth = addressName && addressName.clientWidth  // 显示宽度
      if (scrollWidth > clientWidth) {
        const addressDeliver = this.$el.querySelector('.address-deliver') as HTMLElement
        addressDeliver && (addressDeliver.style.marginLeft = '0')
        addressName.style.width = clientWidth + 'px'  // 固定门店名称的显示宽度，避免分割线左间距减小后，省略内容又有空间展示出来了
      }
    }, 500)
  }

}

